module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_2.e000b5f2.jpeg";